import { StoreState } from ".."
import { AlertValues } from "../../interfaces/alert/AlertState"

export const selectAlert = (state: StoreState): AlertValues | null => {
    if (state.AlertReducer.alert) {
        return state.AlertReducer.alert
    }

    return null
}